import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_FELLOWSHIP_LOAD,
    ACTION_FELLOWSHIP_LOAD_BY_ID,
    ACTION_FELLOWSHIP_LOAD_BY_PERSONNEL_ID,

    ACTION_FELLOWSHIP_SAVE,

    ACTION_FELLOWSHIP_CREATE,

    ACTION_FELLOWSHIP_VALIDATE,

    IFellowshipLoadAction,
    IFellowshipLoadByIdAction,
    IFellowshipsLoadByPersonnelIdAction,
    IFellowshipLoadFailureAction,
    IFellowshipLoadSuccessAction,

    IFellowshipSaveAction,
    IFellowshipSaveSuccessAction,
    IFellowshipSaveFailureAction,

    IFellowshipCreateAction,
    IFellowshipCreateSuccessAction,
    IFellowshipCreateFailureAction,

    IFellowshipValidateAction,
    IFellowshipValidateSuccessAction,
    IFellowshipValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/fellowship";
import { fellowshipsApi } from 'src/services/fellowships';

export const
    getFellowshipsEpic = (action$): Observable<IFellowshipLoadSuccessAction | IFellowshipLoadFailureAction> => {
        return action$
            .ofType(ACTION_FELLOWSHIP_LOAD)
            .mergeMap((_action: IFellowshipLoadAction) => {
                return fellowshipsApi
                    .getFellowships()
                    .map(response =>
                        LoadSuccess(response.fellowships, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getFellowshipsByIdEpic = (action$): Observable<IFellowshipLoadSuccessAction | IFellowshipLoadFailureAction> => {
        return action$
            .ofType(ACTION_FELLOWSHIP_LOAD_BY_ID)
            .mergeMap((action: IFellowshipLoadByIdAction) => {
                return fellowshipsApi
                    .getFellowshipById(action.id)
                    .map(response =>
                        LoadSuccess(response.fellowship, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getFellowshipsByPersonnelIdEpic = (action$): Observable<IFellowshipLoadSuccessAction | IFellowshipLoadFailureAction> => {
        return action$
            .ofType(ACTION_FELLOWSHIP_LOAD_BY_PERSONNEL_ID)
            .mergeMap((action: IFellowshipsLoadByPersonnelIdAction) => {
                return fellowshipsApi
                    .getFellowshipsByPersonnelId(action.personnelId)
                    .map(response =>
                        LoadSuccess(response.fellowships, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setFellowshipEpic = (action$): Observable<IFellowshipSaveSuccessAction | IFellowshipSaveFailureAction> => {
        return action$
            .ofType(ACTION_FELLOWSHIP_SAVE)
            .mergeMap((action: IFellowshipSaveAction) => {
                return fellowshipsApi
                    .setFellowship(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.fellowship, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createFellowshipEpic = (action$): Observable<IFellowshipCreateSuccessAction | IFellowshipCreateFailureAction> => {
        return action$
            .ofType(ACTION_FELLOWSHIP_CREATE)
            .mergeMap((action: IFellowshipCreateAction) => {
                return fellowshipsApi
                    .createFellowship(action.personnelId)
                    .map(response =>
                        CreateSuccess(response.fellowship, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateFellowshipEpic = (action$): Observable<IFellowshipValidateSuccessAction | IFellowshipValidateFailureAction> => {
        return action$
            .ofType(ACTION_FELLOWSHIP_VALIDATE)
            .mergeMap((action: IFellowshipValidateAction) => {
                return fellowshipsApi
                    .validateFellowship(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.fellowship, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



